import {request} from './repository';

const url = 'questions-options/';


const questionOptionStore = {
    storeQuestionOption(data) {
        return request.post(url, data);
    },
    updateQuestionOption(id, data) {
        return request.put(url + id, data);
    },
    deleteQuestionOption(id) {
        return request.delete(url + id);
    },
    reorderQuestionOptions(data) {
        return request.post(url + 'reorder', data);
    },
}

export default questionOptionStore;
